<div class="formulario-contenido-menu" *ngIf="dentroDeMenu || visible">
  <div class="formulario-header">
    <h2>Subir resumen Firmado</h2>
    <p class="subtitulo">
      Cargue el resumen firmado de la visita.
    </p>
    <ion-button fill="clear" size="small" class="btn-cerrar" (click)="cerrar()" aria-label="Cerrar panel">
      <ion-icon slot="icon-only" name="close-outline"></ion-icon>
    </ion-button>
  </div>

  <div class="formulario-content">
    <div class="campo-archivo-resumen">
      <label class="etiqueta-archivo" for="input-resumen-firmado-visita">Resumen firmado (Único)</label>

      <div class="archivo-existente-resumen" *ngIf="adjuntoExistente as adj">
        <span class="nombre-archivo-existente" [title]="adj.nombre_archivo">{{ adj.nombre_archivo }}</span>
        <ion-button
          fill="clear"
          size="small"
          class="btn-ver-archivo-resumen"
          (click)="verArchivoExistente()"
          [disabled]="subiendo || eliminando"
          title="Ver documento"
          [attr.aria-label]="'Ver documento ' + adj.nombre_archivo">
          <ion-icon slot="icon-only" name="eye-outline"></ion-icon>
        </ion-button>
        <ion-button
          fill="clear"
          size="small"
          color="danger"
          class="btn-eliminar-archivo-resumen"
          (click)="eliminarArchivoExistente()"
          [disabled]="subiendo || eliminando"
          title="Eliminar documento"
          aria-label="Eliminar resumen firmado">
          <ion-spinner *ngIf="eliminando" slot="icon-only" name="crescent" aria-hidden="true"></ion-spinner>
          <ion-icon *ngIf="!eliminando" slot="icon-only" name="trash-outline" aria-hidden="true"></ion-icon>
        </ion-button>
      </div>

      <input
        #fileInput
        id="input-resumen-firmado-visita"
        type="file"
        class="file-input-oculto"
        [attr.accept]="fileAccept"
        (change)="onArchivoChange($event)" />
      <button
        type="button"
        class="zona-carga-resumen"
        [class.zona-cargando]="subiendo"
        (click)="activarSelectorArchivo(fileInput)"
        [disabled]="subiendo || eliminando"
        [attr.aria-busy]="subiendo"
        [attr.aria-label]="subiendo ? 'Subiendo archivo' : (nombreArchivoMostrar || 'Seleccionar resumen firmado')">
        <ng-container *ngIf="subiendo; else contenidoZonaNormal">
          <ion-spinner name="crescent" class="spinner-zona-carga" aria-hidden="true"></ion-spinner>
          <span class="texto-principal">Subiendo archivo…</span>
          <span class="texto-hint" *ngIf="nombreArchivoMostrar">{{ nombreArchivoMostrar }}</span>
        </ng-container>
        <ng-template #contenidoZonaNormal>
          <ion-icon name="cloud-upload-outline" class="icono-carga" aria-hidden="true"></ion-icon>
          <span class="texto-principal">
            {{ nombreArchivoMostrar || 'Seleccione el resumen firmado' }}
          </span>
          <span class="texto-hint">PDF, JPG o PNG (Máx 5MB)</span>
        </ng-template>
      </button>
    </div>
  </div>

  <div class="formulario-footer">
    <ion-button fill="outline" (click)="cerrar()" [disabled]="subiendo || eliminando">Cancelar</ion-button>
    <ion-button (click)="onSubirClick()" [disabled]="subiendo || eliminando || !archivoSeleccionado">
      <ion-spinner *ngIf="subiendo" slot="start" name="crescent" aria-hidden="true"></ion-spinner>
      <ion-icon *ngIf="!subiendo" slot="start" name="cloud-upload-outline"></ion-icon>
      {{ textoBotonPrincipal }}
    </ion-button>
  </div>
</div>
